import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/savings`;

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return { headers: { Authorization: `Bearer ${token}` } };
};

const getAll = async () => {
    const response = await axios.get(API, getAuthHeader());
    return response.data;
};

const create = async (data) => {
    const response = await axios.post(API, data, getAuthHeader());
    return response.data;
};

const update = async (id, data) => {
    const response = await axios.put(`${API}/${id}`, data, getAuthHeader());
    return response.data;
};

const remove = async (id) => {
    const response = await axios.delete(`${API}/${id}`, getAuthHeader());
    return response.data;
};

const addFunds = async (id, amount) => {
    const response = await axios.post(`${API}/${id}/add`, { amount }, getAuthHeader());
    return response.data;
};

const withdrawFunds = async (id, amount) => {
    const response = await axios.post(`${API}/${id}/withdraw`, { amount }, getAuthHeader());
    return response.data;
};

const savingsService = {
    getAll,
    create,
    update,
    remove,
    addFunds,
    withdrawFunds,
};

export default savingsService;
